import { Serializable } from '../../core/models/serializable';
export class WorldLanguageModel implements Serializable<WorldLanguageModel> {
  fromObject(obj: any): WorldLanguageModel {
    Object.assign(this, obj);

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public worldLanguageId: number;
  public name: string;
}
